import React from 'react';

function niceMax(value) {
    if (value <= 0) return 5;
    const pow = 10 ** Math.floor(Math.log10(value));
    return Math.ceil(value / pow) * pow;
}

export function SimpleLineChart({ data, dataKey, labelKey, stroke = '#E53E3E', fill = 'rgba(229, 62, 62, 0.25)', height = 260 }) {
    if (!data?.length) {
        return <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>Нет данных</div>;
    }

    const width = 100;
    const pad = { t: 8, r: 4, b: 18, l: 8 };
    const innerW = width - pad.l - pad.r;
    const innerH = height * 0.35;
    const maxY = niceMax(Math.max(...data.map((d) => d[dataKey] || 0), 1));

    const points = data.map((d, i) => {
        const x = pad.l + (i / Math.max(data.length - 1, 1)) * innerW;
        const y = pad.t + innerH - ((d[dataKey] || 0) / maxY) * innerH;
        return `${x},${y}`;
    }).join(' ');

    const areaPoints = `${pad.l},${pad.t + innerH} ${points} ${pad.l + innerW},${pad.t + innerH}`;

    const ticks = 4;
    const yLabels = Array.from({ length: ticks + 1 }, (_, i) => Math.round(maxY - (maxY / ticks) * i));

    return (
        <div style={{ height, position: 'relative' }}>
            <div style={{ position: 'absolute', left: 0, top: 0, bottom: 24, width: 36, fontSize: 10, color: '#9ca3af' }}>
                {yLabels.map((v) => (
                    <div key={v} style={{ height: `${100 / ticks}%`, lineHeight: 1 }}>{v}</div>
                ))}
            </div>
            <svg viewBox={`0 0 ${width} ${innerH + pad.t + pad.b}`} width="100%" height={height - 20} preserveAspectRatio="none" style={{ marginLeft: 32 }}>
                {[0, 1, 2, 3, 4].map((i) => (
                    <line
                        key={i}
                        x1={pad.l}
                        y1={pad.t + (innerH / 4) * i}
                        x2={pad.l + innerW}
                        y2={pad.t + (innerH / 4) * i}
                        stroke="#374151"
                        strokeDasharray="2 2"
                    />
                ))}
                <polygon points={areaPoints} fill={fill} />
                <polyline points={points} fill="none" stroke={stroke} strokeWidth="0.6" />
            </svg>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 32, fontSize: 10, color: '#9ca3af' }}>
                <span>{data[0]?.[labelKey]}</span>
                <span>{data[Math.floor(data.length / 2)]?.[labelKey]}</span>
                <span>{data[data.length - 1]?.[labelKey]}</span>
            </div>
        </div>
    );
}

export function SimpleBarChart({ data, labelKey = 'status', valueKey = 'count', height = 260 }) {
    if (!data?.length) {
        return <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>Нет данных</div>;
    }

    const maxY = niceMax(Math.max(...data.map((d) => d[valueKey] || 0), 1));
    const barW = Math.min(48, Math.floor(280 / data.length) - 8);

    return (
        <div style={{ height, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '0 8px 8px' }}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-around', gap: 12, borderBottom: '1px solid #374151' }}>
                {data.map((d) => {
                    const hPct = ((d[valueKey] || 0) / maxY) * 100;
                    return (
                        <div key={d[labelKey]} style={{ textAlign: 'center', flex: 1, maxWidth: barW + 20 }}>
                            <div style={{ fontSize: 11, color: '#f9fafb', marginBottom: 4 }}>{d[valueKey]}</div>
                            <div
                                style={{
                                    height: `${Math.max(hPct, 2)}%`,
                                    minHeight: 4,
                                    maxHeight: 180,
                                    width: barW,
                                    margin: '0 auto',
                                    background: d.fill || '#48bb78',
                                    borderRadius: '4px 4px 0 0',
                                }}
                            />
                        </div>
                    );
                })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 8, fontSize: 11, color: '#9ca3af' }}>
                {data.map((d) => (
                    <span key={d[labelKey]} style={{ flex: 1, textAlign: 'center' }}>{d[labelKey]}</span>
                ))}
            </div>
        </div>
    );
}
